exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-UomBlock-container{font-size:12px;position:relative;float:left;border:2px solid #666;border-top:none}.src-components-shared-UomBlock-inactive{color:#a7b5bd}", ""]);

// exports
exports.locals = {
	"container": "src-components-shared-UomBlock-container",
	"inactive": "src-components-shared-UomBlock-inactive"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/UomBlock/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/UomBlock/styles.scss
// module chunks = 1